angular.module('SpidApp')

.filter('numericWithSpaces', function () {
    return function (val) {
        var retour = '';
        var count = 0;

        if (val) {
	        var decimalCheck = (''+val).split('.');
	        var nombre = '' + decimalCheck[0].replace(/,/g, '');
	
	        for (var i = nombre.length - 1; i >= 0; i--) {
	            if (count !== 0 && count % 3 === 0) {
	                retour = nombre[i] + ' ' + retour;
	            } else {
	                retour = nombre[i] + retour;
	            }
	            count++;
	        }
	
	        if (!angular.isUndefined(decimalCheck[1])) {
	            retour = retour + '.' + decimalCheck[1];
	        }
        }

        return retour;
    }
})